module.exports = __webpack_public_path__ + "img/Nikkei-sp.355bfa76.jpg";